module.exports = __webpack_public_path__ + "static/img/brees-2011-slide-5.46a7ae4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2011-slide-5.jpg
// module id = bXKc
// module chunks = 1